import { render } from "./AllContactList.vue?vue&type=template&id=319ba19e&scoped=true"
import script from "./AllContactList.vue?vue&type=script&lang=js"
export * from "./AllContactList.vue?vue&type=script&lang=js"

import "./AllContactList.vue?vue&type=style&index=0&id=319ba19e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319ba19e"]])

export default __exports__